import { SupportedChainId } from "./chains";

// Arbitrum
export const arbToken = {
  WETH: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
  USDC: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
};

export const arbUniPool = {
  WETH_USDC_500: "0xc31e54c7a869b9fcbecc14363cf510d1c41fa443",
  WETH_USDC_3000: "0x17c14d2c404d167802b16c450d3c99f88f2c4f4d",
};

// Goerli
export const goerToken = {
  WETH: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
  UNI: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
  DAI: "0xdc31Ee1784292379Fbb2964b3B9C4124D8F89C60",
};

export const goerUniPool = {
  WETH_UNI: "0x07A4f63f643fE39261140DF5E613b9469eccEC86",
  WETH_DAI: "0x1738f9aAB1d370a6d0fd56a18f113DbD9e1DCd4e",
};

export const UNI_POSITION_MANAGER =
  "0xC36442b4a4522E871399CD717aBDD847Ab11FE88";

export const ALL_TOKENS: { [key: string]: { [key: string]: string } } = {
  [SupportedChainId.ARBITRUM_ONE]: arbToken,
  [SupportedChainId.GOERLI]: goerToken,
};

export const ALL_UNI_POOLS: { [key: string]: { [key: string]: string } } = {
  [SupportedChainId.ARBITRUM_ONE]: arbUniPool,
  [SupportedChainId.GOERLI]: goerUniPool,
};
